import React from 'react';
import OfflineComponent from './Offline';

/**
 * Error Boundary compoenent return with Error message or Offline COmponent
 * @class ErrorBoundary
 */
class ErrorBoundary extends React.Component {

    constructor(props) {
      super(props);
      this.state = { hasError: false, error: '' };
    }
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, error: error };
    }

    componentDidCatch(error, info) {
      // You can also log the error to an error reporting service
      // logErrorToMyService(error, info);
    }

     /**
     * a render method of this component
     * @memberof ErrorBoundary
     * @function render
     * @returns {div}
     */
    render() {
      if (this.state.hasError && !navigator.onLine) {
        // You can render any custom fallback UI
        return <OfflineComponent />;
      } else if(this.state.hasError) {
        return (<div><h1>something went wrong</h1><br/><h2>Refresh the page/close and open the app</h2></div>);
      }
      return this.props.children;
    }
  }

  export default ErrorBoundary;
